import { Route } from "react-router-dom";
import { AuthenticationGuard } from "@/components/AuthenticationGuard/AuthenticationGuard";
import MainLayout from "@/components/MainLayout/MainLayout";
import PermissionGuard from "@/components/PermissionGuard/PermissionGuard";
import DashboardPage from "@/modules/stochastic/features/Reports/SCDashboard/components/DashboardPage/DashboardPage";
import MemberDashboardPage from "@/modules/hub/features/MemberDashboard/components/MemberDashboardPage/MemberDashboardPage";
import TotalAddressableMarketPage from "@/modules/stochastic/features/TotalAddressableMarket/components/TotalAddressableMarketPage/TotalAddressableMarketPage";

const DashboardsMainLayout = () => <MainLayout section="dashboards" />;

/**
 * The Dashboards section: member-facing analytics dashboards under their
 * own app-strip section and layout. The pages are the same components the
 * old locations rendered — only the routes and the surrounding section
 * moved. Total Addressable Market also remains reachable at its original
 * Lead Generation URL (deliberate duplicate; see dashboardsNavigation).
 */
const DashboardsRoutes = (
  <Route
    element={<AuthenticationGuard component={DashboardsMainLayout} />}
    path="/dashboards"
  >
    <Route
      element={
        <PermissionGuard requiredPermissions={["stochastic-dashboard"]}>
          <DashboardPage />
        </PermissionGuard>
      }
      path="sales-and-customer-dashboard"
    />

    <Route
      element={
        <PermissionGuard requiredPermissions={["member-dashboard"]}>
          <MemberDashboardPage />
        </PermissionGuard>
      }
      path="member-dashboard"
    />

    <Route
      element={
        <PermissionGuard
          requiredPermissions={["stochastic-total-addressable-market"]}
        >
          <TotalAddressableMarketPage />
        </PermissionGuard>
      }
      path="total-addressable-market"
    />
  </Route>
);

export default DashboardsRoutes;
